'use client';

import utilsStyles from '@/styles/modules/utils.module.scss';
import { useState } from 'react';
import type { Faq, FaqCategory } from '../../types';
import FaqDetailAccordion from '../FaqDetailAccordion/FaqDetailAccordion';
import styles from './FaqList.module.scss';

type Props = {
  items: Array<FaqCategory>;
};

type IsOpenItem = {
  faqId: number;
  isOpen: boolean;
};

function FaqList({ items }: Props) {
  const faqIsOpenInitial = (items: Array<FaqCategory>) => {
    const result: IsOpenItem[] = [];
    items.forEach((item) => {
      item.faq.forEach((faq) => {
        result.push({ faqId: faq.id, isOpen: false });
      });
    });
    return result;
  };

  const [isOpenList, setIsOpenList] = useState<IsOpenItem[]>(faqIsOpenInitial(items));

  const handleClick = (id: number, result: IsOpenItem[]) => {
    return result.map((item) => (item.faqId === id ? { ...item, isOpen: !item.isOpen } : item));
  };

  const faqItemList = (faqItemList: Array<Faq>) => {
    return (
      <ul className={styles.faqs}>
        {faqItemList.map((faq, index) => (
          <li key={`faq_${faq.id}`} className={`${index !== faqItemList.length - 1 ? styles.borderBottom : ''}`}>
            <FaqDetailAccordion
              isOpen={isOpenList.find((item: IsOpenItem) => item.faqId === faq.id)?.isOpen ?? false}
              setIsOpen={() => setIsOpenList((prev) => handleClick(faq.id, prev))}
              faqDetailDescription={faq.description}
              title={faq.title}
            />
          </li>
        ))}
      </ul>
    );
  };

  return (
    <ul className={styles.faqList}>
      {items.map((category, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
        <li key={index} className={styles.faqContainer}>
          <h2 className={`${styles.sectionTitle} ${utilsStyles.textBold}`}>{category.faqCategoryName}</h2>
          {faqItemList(category.faq)}
        </li>
      ))}
    </ul>
  );
}

export default FaqList;
